import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { TegelModule } from '@scania/tegel-angular-17';
import { ModalService } from '../../services/modal.service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-confirmation-modal',
  templateUrl: './confirmation-modal.component.html',
  styleUrls: ['./confirmation-modal.component.scss'],
  standalone: true,
  imports: [TegelModule],
})
export class ConfirmationModalComponent {
  @Input() size: string = 'xs';
  @Input() modalId!: string;
  @Input() title!: string;
  @Input() message!: string;
  @Input() confirmationButtonMsg: string = 'Delete';
  @Input() cancelationButtonMsg: string = 'Cancel';

  // eslint-disable-next-line @angular-eslint/prefer-inject
  constructor(public modalService: ModalService) {}
}
